<template>
  <div
    class="c-loader"
    :style="durationAnimation"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  duration?: number | string
}

const props = withDefaults(defineProps<Props>(), {
  duration: '',
})

const durationAnimation = computed(() => {
  return {
    'animation-duration': props.duration ? `${props.duration}s` : '',
  }
})
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CLoader',
})
</script>
